import {
  faBanSmoking,
  faBicycle,
  faBox,
  faCameraCctv,
  faCarGarage,
  faChampagneGlass,
  faChargingStation,
  faDumbbell,
  faElevator,
  faFire,
  faGarageCar,
  faGrillHot,
  faLaptop,
  faMountainSun,
  faPaw,
  faPerson,
  faPersonSwimming,
  faPersonWalkingWithCane,
  faPipeSection,
  faPipeValve,
  faSeedling,
  faShelves,
  faShower,
  faSpa,
  faTablePicnic,
  faTeddyBear,
  faTrainSubway,
  faTrees,
  faUserDoctor,
  faUtensils,
  faWashingMachine,
  faWater,
} from '@fortawesome/pro-solid-svg-icons';
import type { CustomIconDefinition } from '@/common/custom-icons.ts';

export const faSolidIcons: CustomIconDefinition[] = [
  { library: 'fa-solid', name: 'ban-smoking', icon: faBanSmoking },
  { library: 'fa-solid', name: 'bicycle', icon: faBicycle },
  { library: 'fa-solid', name: 'box', icon: faBox },
  { library: 'fa-solid', name: 'camera-cctv', icon: faCameraCctv },
  { library: 'fa-solid', name: 'car-garage', icon: faCarGarage },
  { library: 'fa-solid', name: 'champagne-glass', icon: faChampagneGlass },
  { library: 'fa-solid', name: 'charging-station', icon: faChargingStation },
  { library: 'fa-solid', name: 'dumbbell', icon: faDumbbell },
  { library: 'fa-solid', name: 'elevator', icon: faElevator },
  { library: 'fa-solid', name: 'fire', icon: faFire },
  { library: 'fa-solid', name: 'garage-car', icon: faGarageCar },
  { library: 'fa-solid', name: 'grill-hot', icon: faGrillHot },
  { library: 'fa-solid', name: 'laptop', icon: faLaptop },
  { library: 'fa-solid', name: 'mountain-sun', icon: faMountainSun },
  { library: 'fa-solid', name: 'paw', icon: faPaw },
  { library: 'fa-solid', name: 'person', icon: faPerson },
  { library: 'fa-solid', name: 'person-swimming', icon: faPersonSwimming },
  { library: 'fa-solid', name: 'person-walking-with-cane', icon: faPersonWalkingWithCane },
  { library: 'fa-solid', name: 'pipe-section', icon: faPipeSection },
  { library: 'fa-solid', name: 'pipe-valve', icon: faPipeValve },
  { library: 'fa-solid', name: 'seedling', icon: faSeedling },
  { library: 'fa-solid', name: 'shelves', icon: faShelves },
  { library: 'fa-solid', name: 'shower', icon: faShower },
  { library: 'fa-solid', name: 'spa', icon: faSpa },
  { library: 'fa-solid', name: 'table-picnic', icon: faTablePicnic },
  { library: 'fa-solid', name: 'teddy-bear', icon: faTeddyBear },
  { library: 'fa-solid', name: 'train-subway', icon: faTrainSubway },
  { library: 'fa-solid', name: 'trees', icon: faTrees },
  { library: 'fa-solid', name: 'user-doctor', icon: faUserDoctor },
  { library: 'fa-solid', name: 'utensils', icon: faUtensils },
  { library: 'fa-solid', name: 'washing-machine', icon: faWashingMachine },
  { library: 'fa-solid', name: 'water', icon: faWater },
];
